import React, { useRef, useState } from 'react'
import Card from '../../shared/card/Card'
import { ScrollView, View, Text, ActivityIndicator } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import CustomButton from '../../shared/button/Button'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import Toast from 'react-native-toast-message'
import moment from 'moment'
import Canvas from '../../canvas'
import SignatureFormView from '../SignatureFormView'

const PaInformationonline = ({ navigation, route }) => {
    const {
        values,
        userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
        essFormKey,
        ids
    } = route.params

    const personalstore = usePersonalStore()
    const intializestore = useInitializeStore()

    const { postpaonline, loading, modetailsData, papsdcode } = useFormsStore()

    // const canvasRef = useRef(null)
    const [hasDrawn, setHasDrawn] = useState(false);
    const [isDrawing, setIsDrawing] = useState(false)
    const [signatureDataURL, setSignatureDataURL] = useState('')






    const handlesubmit = async (signatureDataURL: any) => {
        const data = {
            essUserKey: intializestore.initializeData?.userkey,
            entityId: personalstore.personalData?.entityId,
            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
            essObKey: essUserOnBoardingKey,
            completeOnline: true,
            sign: signatureDataURL,
            municipality: values.municipality,
            county: values.county,
            residentPsdcode: Number(values.residentpsdcode),
            totalResdientEitrate: Number(values.totalresidenteitrate),
            WorkLocationPsdcode: papsdcode?.workPsdCode,
            WorkCounty: papsdcode?.workCounty,
            WorkMunicipality: papsdcode?.workLocation,
            totalNonResdientEitrate: Number(papsdcode?.workNonResidentEit.replace(/[^0-9.-]+/g, ""))
        }
        const response = await postpaonline(data)
        if (response?.success) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        }
        else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }

    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'PA Withholding Taxation '}
                    />
                </View>
            </View>
            <SignatureFormView
                essUserOnBoardingFormKey={essUserOnBoardingFormKey}
                essUserOnBoardingKey={essUserOnBoardingKey}
                isSubmitting={loading}
                onPrevious={() =>
                    navigation.navigate('painformationTable', {
                        mostRecentUserOnBoardings: userId,
                        mode: "online",
                        essUserOnBoardingKey,
                        essUserOnBoardingFormKey,
                        essFormKey,
                        values,
                    })
                }
                onSubmit={handlesubmit}
            />
        </>
    )
}
export default PaInformationonline
